const root = '/home-card-motion/onyx';
const object = (name, file, className) => ({ name, src: `${root}/${file}.webp`, className });

export const onyxArtworkLayers = {
  leaderboard: {
    base: '/home-cards-v5/onyx/leaderboard.webp',
    layers: [object('gem', 'trophy-gem', 'onyx-light onyx-trophy-gem')],
    sheen: 'trophy-gem',
  },
  'wager-rewards': {
    base: `${root}/wager-milestones-3d-v6.webp`,
    layers: [
      object('ranks', 'milestone-rank-metals-v6', 'onyx-light onyx-rank-metals'),
      object('rewards', 'milestone-gaming-props-v6', 'onyx-light onyx-milestone-rewards'),
    ],
    sheen: 'milestone-rank-metals-v6',
  },
  originals: {
    base: '/home-cards-v5/onyx/originals.webp',
    layers: [
      object('chip', 'v-chip', 'onyx-light onyx-v-chip'),
    ],
    sheen: 'v-chip',
  },
  store: {
    base: `${root}/store-base.webp`,
    layers: [
      object('shackle', 'lock-shackle', 'onyx-lock-shackle'),
      object('items', 'cart-items', 'onyx-light onyx-cart-items'),
    ],
  },
  vip: {
    width: 1264,
    height: 848,
    base: '/home-cards-v5/onyx/vip.webp',
    layers: [
      object('gems', 'vip-crown-gems', 'onyx-light onyx-vip-gems'),
      object('card', 'vip-membership-card', 'onyx-light onyx-vip-card-glow'),
    ],
    sheen: 'vip-membership-card',
  },
};